if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {

    function PictureOverlay(bounds, image, map, display) {
        if (typeof display === 'undefined') {
            display = 'block';
        }
        // Initialize all properties.
        this.bounds_ = bounds;
        this.image_ = image;
        this.map_ = map;
        this.display_ = display;
        this.image_attached_ = false;

        // Define a property to hold the image's div. We'll
        // actually create this div upon receipt of the onAdd()
        // method so we'll leave it null for now.
        this.div_ = null;

        // Explicitly call setMap on this overlay.
        this.setMap(map);
    }

    PictureOverlay.prototype = new google.maps.OverlayView();

    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    PictureOverlay.prototype.onAdd = function() {
        var div = document.createElement('div');
        div.style.borderStyle = 'none';
        div.style.borderWidth = '0px';
        div.style.position = 'absolute';
        div.style.display = this.display;

        this.div_ = div;

        if (this.display_ == 'block') {
            this.attachImage();
        }

        // Add the element to the "overlayLayer" pane.
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(div);
    };

    /**
     * attachImage is called when the overlay is set as visible
     */
    PictureOverlay.prototype.attachImage = function() {
        if (!this.image_attached_) {
            // Create the img element and attach it to the div.
            var img = document.createElement('img');
            img.src = this.image_;
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.position = 'absolute';
            this.div_.appendChild(img);
            this.image_attached_ = true;
        }
    };



    /* Draw the Overlay */
    PictureOverlay.prototype.draw = function() {

        // We use the south-west and north-east
        // coordinates of the overlay to peg it to the correct position and size.
        // To do this, we need to retrieve the projection from the overlay.
        var overlayProjection = this.getProjection();

        // Retrieve the south-west and north-east coordinates of this overlay
        // in LatLngs and convert them to pixel coordinates.
        // We'll use these coordinates to resize the div.
        var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
        var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

        // Resize the image's div to fit the indicated dimensions.
        var div = this.div_;
        div.style.left = sw.x + 'px';
        div.style.top = ne.y + 'px';
        div.style.width = (ne.x - sw.x) + 'px';
        div.style.height = (sw.y - ne.y) + 'px';
    };

    // The onRemove() method will be called automatically from the API if
    // we ever set the overlay's map property to 'null'.
    PictureOverlay.prototype.onRemove = function() {
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    };

    PictureOverlay.prototype.setDisplay = function(display) {
        this.display_ = display;
        if (this.display_ == 'block') {
            this.attachImage();
        }
        this.div_.style.display=display;
    };
}

var markers=[], maps=[], infowindow, overlays = {};






function initialize_map_by_config(config) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    markers[config.div_id] = [];
    overlays[config.div_id] = {};
    var center = new google.maps.LatLng(39.929200, 9.710968);
    if (typeof config.center !== 'undefined') {
        center = new google.maps.LatLng(parseFloat(config.center.latitude, 10), parseFloat(config.center.longitude, 10));
    }

    var gmapOptions = {
        mapTypeId:	google.maps.MapTypeId['ROADMAP'],
        scrollwheel: false,
        mapTypeControl: false,
        panControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
        },
        center:center,
        zoom:parseInt(config.zoom, 10)
    }, key;

    // styles
    config['styles'] = [];
    config['styles'].push( {"featureType": "poi.business", "stylers": [{"visibility": "off"}]} );

    maps[config.div_id] = new google.maps.Map(document.getElementById(config.div_id), gmapOptions);
    if (typeof config.map_overlay !== 'undefined') {
        for (key in config.overlays) {
            var overlayData = config.overlays[key];
            var swBound = new google.maps.LatLng(overlayData.coords.sw.latitude, overlayData.coords.sw.longitude);
            var neBound = new google.maps.LatLng(overlayData.coords.ne.latitude, overlayData.coords.ne.longitude);
            var bounds_overlay = new google.maps.LatLngBounds(swBound, neBound);
            overlays[config.div_id][key] = new PictureOverlay(bounds_overlay, overlayData.url, maps[config.div_id], overlayData.display);
        }
    }

    if (typeof config['styles'] !== 'undefined') {
        maps[config.div_id].setOptions({styles: config['styles']});
    }


}

function load_markers_by(filter, value, config, area) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if (typeof maps[config.div_id] === 'undefined') {
        console.log('fail');
        return;
    }
    clean_markers(config);
    var i, bounds, markerIndex, visible_categories, selectable_categories, visible_markers;
    visible_categories = [];
    selectable_categories = [];
    visible_markers = 0;
    bounds = new google.maps.LatLngBounds();
    for (i=0; i<resort_map_points.length; i++) {
        point = resort_map_points[i];
        var keep=false;
        if(point.latitude == '' ||point.longitude == ''){
            window.console && console.log('skipping point with no coordinates', point);
            continue;
        }
        if(typeof area == 'undefined' || (area != 'general_map' && point.area == area)){
            if(selectable_categories.indexOf(point.category) == -1){
                selectable_categories.push(point.category);
            }
        }
        switch (filter) {
            case 'area':
                if (point.area == value || value == 'general_map') {
                    keep=true;
                }
                break;

            case 'hotel':
                if (point.hotels.indexOf(value) !== -1) {
                    keep=true;
                    if (typeof current_map_area !== 'undefined' && current_map_area != 'all' && point.area != current_map_area) {
                        keep=false;
                    }
                }
                break;

            case 'category':
                if (point.category == value || value == 'all') {
                    keep=true;
                    if ((typeof current_map_area !== 'undefined' && current_map_area != 'all' && point.area != current_map_area)||typeof area !== 'undefined' && (area != 'general_map' && point.area !== area) ) {
                        keep=false;
                    }
                }
                break;

            case 'emotion':
                if (point.emotions.indexOf(value) !== -1) {
                    keep=true;
                    if (typeof current_map_area !== 'undefined' && current_map_area != 'all' && point.area != current_map_area) {
                        keep=false;
                    }
                }
                break;

            default:
                keep=true;
                if (typeof current_map_area !== 'undefined' && current_map_area != 'all' && point.area != current_map_area) {
                    keep=false;
                }
                break;
        }

        if (!keep) continue;
        visible_markers++;
        if(visible_categories.indexOf(point.category) == -1){
            visible_categories.push(point.category);
        }
        markers[config.div_id].push(new google.maps.Marker({
            position : new google.maps.LatLng(point.latitude, point.longitude),
            map : maps[config.div_id],
            icon : point.icon_url,
            title : point.title
        }));
        markerIndex = markers[config.div_id].length - 1;
        markers[config.div_id][markerIndex]._arbatax_point_data = point;

        google.maps.event.addListener(markers[config.div_id][markerIndex], 'click', (function(markerIndex) {
            var marker = markers[config.div_id][markerIndex], point = marker._arbatax_point_data;
            return function() {
                make_infowindow(point, maps[config.div_id], marker);
            };

        })(markerIndex));

        if(!point.no_fit_bounds || (typeof globalEnabledFitBounds !== 'undefined' && globalEnabledFitBounds)){
            bounds.extend(new google.maps.LatLng(point.latitude, point.longitude));
        }

        // WELLNESS CHANGE ZOOM LEVEL AFTER FITBOUNDS
        if(point.category == 'benessere'
            || point.category == 'wellness'
            || point.category == 'bien-etre'
            || point.category == '%d1%81%d0%bf%d0%b0'){
            // CHANGE ZOOM LEVEL AFTER FITBOUNDS
            zoomChangeBoundsListener = google.maps.event.addListenerOnce(maps[config.div_id], 'bounds_changed', function(event) {
                if (this.getZoom()){
                    this.setZoom(17);
                }
            });
            setTimeout(function(){
                google.maps.event.removeListener(zoomChangeBoundsListener)
            }, 1500);
        }

        if(area === 'general_map'){
            zoomChangeBoundsListener = google.maps.event.addListenerOnce(maps[config.div_id], 'bounds_changed', function(event) {
                if (this.getZoom()){
                    if(is_phone || is_mobile || is_desktop){
                        this.setZoom(15);
                    }
                    if(is_tablet_landscape){
                        this.setZoom(15.5);
                    }

                    if(is_desktop_large){
                        this.setZoom(15.9);
                    }
                    if(value === 'beaches'||
                       value === 'spiagge' ||
                       value === 'plages' ||
                       value === 'strande' ||
                       value === '%d0%bf%d0%bb%d1%8f%d0%b6%d0%b8' ||
                       value === 'playas'){
                        this.setZoom(14);
                        if(is_phone){
                            this.setZoom(13.5);
                        }
                    }
                }
            });
            setTimeout(function(){
                google.maps.event.removeListener(zoomChangeBoundsListener)
            }, 1500);
        }
    }

    if(visible_markers == 1){
        zoomChangeBoundsListener = google.maps.event.addListenerOnce(maps[config.div_id], 'bounds_changed', function(event) {
            if (this.getZoom()){
                this.setZoom(17);
            }
        });
        setTimeout(function(){
            google.maps.event.removeListener(zoomChangeBoundsListener)
        }, 1500);
    }

    if(visible_markers == 0){
        $('.filter-category-wrap select').val('all').trigger('change');
        return;
    }
    if(area != 'general_map'){
        $('.filter-category-wrap select option').each(function(){
            var opt = $(this);
            if(selectable_categories.indexOf(opt.val()) == -1 && opt.val() != 'all'){
                opt.prop('disabled', 'disabled');
            } else{
                opt.prop('disabled', false);
            }
        });
    } else{
        $('.filter-category-wrap select option').each(function(){
            var opt = $(this);
            opt.prop('disabled', false);
        });
    }

    $('.all_pois .category .box_item').each(function(){
        var single_item = $(this);
        var cat_item = single_item.data('poi-category');
        if(visible_categories.indexOf(cat_item) == -1){
            single_item.addClass('hidden');
        } else{
            single_item.removeClass('hidden');
        }
    });

    if (typeof config.fitBounds === 'undefined' || (typeof config.fitBounds !== 'undefined' && config.fitBounds === true)) {
        maps[config.div_id].fitBounds(bounds);
    }
}

function make_infowindow(point, map, marker) {
    /*SISTEMARE*/
    var contentString = '<div class="map-marker-popup"><span class="hotelname">'+point.title+'</span></div>';
    if (typeof infowindow !== 'undefined') {
        infowindow.close();
    }
    infowindow = new google.maps.InfoWindow({ content : contentString });
    map.setCenter(new google.maps.LatLng(point.latitude, point.longitude));
    infowindow.open(map,marker);
}


function clean_markers(config) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if (typeof markers[config.div_id] !== 'undefined') {
        var i;
        for (i = 0; i < markers[config.div_id].length; i++) {
            markers[config.div_id][i].setMap(null);
        }
        markers[config.div_id] = [];
    }
}

function map_show_point(slug, link, config) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if  (typeof link !== 'undefined') {
        jQuery('.single-category-trigger.active').removeClass('active');
        jQuery(link).closest('.single-category-trigger').find('> a').click();
        jQuery(link).closest('.single-category-trigger').addClass('active');

        //Scroll to top only mobile version
        if(jQuery('html').hasClass('mq_phone')){
            if(jQuery('html').hasClass('resort_page')){
                jQuery('html,body').animate({ scrollTop: 0 }, 'slow');
            }
        }
    }
    if (typeof markers[config.div_id] !== 'undefined') {
        var i;
        for (i = 0; i < markers[config.div_id].length; i++) {
            if (markers[config.div_id][i]._arbatax_point_data.slug == slug) {
                make_infowindow(markers[config.div_id][i]._arbatax_point_data, maps[config.div_id], markers[config.div_id][i]);
                return;
            }
        }
    }

}

function map_toggle_category(category, element, area) {
    area = area || 'general_map';
    if(area === 'general_map'){
        if(category != 'all'){
            window.globalEnabledFitBounds = true;
            load_markers_by('category', category, resort_map_config, area);
            window.globalEnabledFitBounds = false;
        } else{
            window.globalEnabledFitBounds = false;
            load_markers_by('category', category, resort_map_config, area);
        }
    } else {
        window.globalEnabledFitBounds = true;
        load_markers_by('category', category, resort_map_config, area);
        window.globalEnabledFitBounds = false;
    }

    if  (typeof element !== 'undefined') {
        jQuery('.single-category-trigger.active').removeClass('active');
        jQuery(element).closest('li').addClass('active');

        //Scroll to top only mobile version
        if(jQuery('html').hasClass('mq_phone')){
            if(jQuery('html').hasClass('resort_page')){
                jQuery('html,body').animate({ scrollTop: 0 }, 'slow');
            }
        }
    }
}

function show_overlay(key, config) {
    var k;
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if (typeof overlays[config.div_id][key] !== 'undefined') {
        for (k in overlays[config.div_id]) {
            overlays[config.div_id][k].setDisplay('none');
        }
        overlays[config.div_id][key].setDisplay('block');
    }
}

function map_toggle_area(area, link, config) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if (typeof link !== 'undefined') {
        jQuery('.single-category-trigger:hidden').show();
        jQuery('.single-category-trigger li:hidden').show();
    }

    current_map_area = area;
    if (area == 'all') {
        map_toggle_area('general_map');
        show_overlay('general', config);
        jQuery('.single-category-trigger').show();
    } else {
        load_markers_by('area', area);
        show_overlay(area, config);
        jQuery('.single-category-trigger').each(function() {
            var area_div = $(this), tmp=area_div.data('availableareas'), availableareas=tmp.split(',');
            if (availableareas.indexOf(area) === -1) {
                area_div.hide();
            } else {
                area_div.addClass('visible_on_map');
                area_div.find('li').each(function() {
                    var li = jQuery(this);
                    if (li.data('area') != area) {
                        li.hide();
                    }
                });
            }

        });
    }
    setTimeout(function(){
        $('#pois_container ul.category').masonry('layout');
    },300);
}

function map_toggle_hotel_area(area, link, config) {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    if (typeof link !== 'undefined') {
        jQuery('.single-category-trigger:hidden').show();
        jQuery('.single-category-trigger li:hidden').show();
    }
    current_map_area = area;

    load_markers_by('area', area);
    show_overlay(area, config);
    jQuery('.single-category-trigger > ul > li').each(function() {
        if (jQuery(this).data('area') == area || area == 'general_map' ) {
            jQuery(this).show();
        } else {
            jQuery(this).hide();
        }
    });
}

function filter_btns_by_area_type(){
    $('.map_buttons li').each(function (){
        var btn = $(this).find('a');
        if(hotel_data['hotel_hid'] == 'itsar24726'){
            if(btn.hasClass('suites')){
                btn.parent().addClass('active');
            }
        } else if(hotel_data['hotel_hid'] == 'itsar24720'|| hotel_data['hotel_hid'] == 'itsar24722' || hotel_data['hotel_hid'] == 'itsar24723'){
            if(btn.hasClass('area_telis')){
                btn.parent().addClass('active');
            }
        }
    });

    if($('.map_buttons li.active:first-child a')){
        if(hotel_data['hotel_hid'] == 'itsar24726'){
            setTimeout(function (){
                $('.filter-category-wrap select').val('suites').trigger('change');
            },50);
        } else if(hotel_data['hotel_hid'] == 'itsar24720' ||
                  hotel_data['hotel_hid'] == 'itsar24722' ||
                  hotel_data['hotel_hid'] == 'itsar24723'){
                setTimeout(function (){
                    $('.filter-category-wrap select').val('hotels').trigger('change');
                },50);
        }
    }

    $('.map_buttons li a').on('click', function(){
        $(this).parent().addClass('active').siblings().removeClass('active');

        if($(this).hasClass('suites')){
            $('.filter-category-wrap select').val('suites').trigger('change');
        } else if($(this).hasClass('area_telis')){
            $('.filter-category-wrap select').val('hotels').trigger('change');
        } else if ($(this).hasClass('general_map') || $(this).hasClass('area_borgo')){
            $('.filter-category-wrap select').val('all').trigger('change');
        } else{
            $('.filter-category-wrap select').trigger('change');
        }
    });
}

function filter_map_by_category(){
    //This is a selector inside the services page
    if($('.filter-category-wrap select').length > 0){
        $('.filter-category-wrap select').on('change',  function(){
            var current_area = $('.map_buttons li.active a').data('area') || undefined;

            map_toggle_category(this.value,this, current_area);
            $('li.single-poi-trigger.hidden').removeClass('hidden');

            var selector_category_value = this.value;
            var poi_category_items = $('.all_pois .category .box_item');
            poi_category_items.each(function(){
                var single_category = $(this).data('poi-category');

                var visible = false;
                 if(selector_category_value === 'all' || selector_category_value === single_category){
                    visible = true;
                 }
                 $(this)[visible ? 'show' : 'hide']();
                 if(visible){
                     var single_item = $(this).find('ul li.single-poi-trigger');
                     single_item.each(function(){
                         var el = $(this);
                         var el_area = el.data('area');
                         if(current_area != 'all' && current_area != 'general_map' && el_area != current_area){
                             el.addClass('hidden');
                         }

                     });
                 }
            });
        });
    }
}

function open_lightbox_map(slug) {

    $('#resort_map_wrapper').addClass('open');
    $('#resort_map_wrapper').addClass('visible');
    setTimeout(function () {
        load_markers_by('emotion', $('#page').data('emotion-slug'));
        map_show_point(slug);
    }, 310);
}

function map_add_standard_marker() {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    markers[config.div_id].push(new google.maps.Marker({
        position: new google.maps.LatLng(default_marker.latitude, default_marker.longitude),
        map: maps[config.div_id],
        icon: default_marker.icon_url,
        title: default_marker.title
    }));
    markerIndex = markers[config.div_id].length - 1;
    markers[config.div_id][markerIndex]._arbatax_point_data = default_marker;

    google.maps.event.addListener(markers[config.div_id][markerIndex], 'click', (function(markerIndex) {
        var marker=markers[config.div_id][markerIndex], point = marker._arbatax_point_data;
        return function() {
            if (typeof infowindow !== 'undefined') {
                infowindow.close();
            }
            infowindow = new google.maps.InfoWindow({ content : point.html });
            maps[config.div_id].setCenter(new google.maps.LatLng(point.latitude, point.longitude));
            infowindow.open(maps[config.div_id],marker);
        };

    })(markerIndex));
}

function map_add_secondary_marker() {
    if (typeof config === 'undefined') {
        config = resort_map_config;
    }
    markers[config.div_id].push(new google.maps.Marker({
        position: new google.maps.LatLng(secondary_marker.latitude, secondary_marker.longitude),
        map: maps[config.div_id],
        icon: secondary_marker.icon_url,
        title: secondary_marker.title
    }));
    markerIndex = markers[config.div_id].length - 1;
    markers[config.div_id][markerIndex]._arbatax_point_data=secondary_marker;

    google.maps.event.addListener(markers[config.div_id][markerIndex], 'click', (function(markerIndex) {
        var marker=markers[config.div_id][markerIndex], point = marker._arbatax_point_data;
        return function() {
            if (typeof infowindow !== 'undefined') {
                infowindow.close();
            }
            infowindow = new google.maps.InfoWindow({ content : point.html });
            infowindow.open(maps[config.div_id],marker);
        };

    })(markerIndex));
}


jQuery(document).ready(function() {
    /**/
});
